"use client";
import React, { useEffect, useState } from "react";
import dynamic from "next/dynamic";

import "../../marken/marken.css";

import { TopSectionMarken } from "../../marken/sections/TopSection";
import { AutoVerkaufenGrid } from "@/common/AutoVerkaufenGrid";
import { Banner } from "@/common/Banner";
import sellCarCash from "@/assets/auto-verkaufen/Rückbank-autoverkauf.avif";

import höchstenPreis from "@/assets/auto-verkaufen/Frau-verkauft-ihr-auto.webp";
import BannerImage3 from "@/assets/auto-verkaufen/AutoeinfachlosBannerBig3.avif";
import BildTextInfo from "@/components/BildTextInfo/BildTextInfo";

// Ratgeber SERVERSEITIG rendern (dynamic OHNE die SSR-Abschaltung, Playbook 2.6):
// die sechs "Mehr zum Thema"-Kacheln verlinken u. a. /auto-verkaufen.
const Ratgeber = dynamic(() =>
  import("@/components/Ratgeber/Ratgeber").then((m) => m.default)
);

// Only needed when the user reaches step 12; avoid loading auth-related JS/CSS on initial paint.
const AnmeldenSection = dynamic(() => import("@/app/anmelden/AnmeldenStepRedirect"), {
  ssr: false,
});

function AlternativeAutoscout24() {
  const [step, setStep] = useState(1);
  // selected values
  const [selectedBrand, setSelectedBrand] = useState({ id: "", name: "" });
  const [selectedModel, setSelectedModel] = useState({ id: "", name: "" });
  const [selectedYear, setSelectedYear] = useState({ id: "", name: "" });
  const [selectedBauform, setSelectedBauform] = useState({ id: "", name: "" });
  const [selectedFuel, setSelectedFuel] = useState({ id: "", name: "" });
  const [selectedVariant, setSelectedVariant] = useState({ id: "", name: "" });
  const [selectedPs, setSelectedPs] = useState({ id: "", name: "" });
  const [selectedTransmission, setSelectedTransmission] = useState({
    id: "",
    name: "",
  });
  const [selectedDoors, setSelectedDoors] = useState({ id: "", name: "" });
  const [selectedModelType, setSelectedModelType] = useState({
    id: "",
    name: "",
  });
  const [selectedKmStand, setSelectedKmStand] = useState("");
  const isSecondaryMethod = true;

  useEffect(() => {
    if (step >= 10) {
      if (typeof AnmeldenSection?.preload === "function") {
        AnmeldenSection.preload();
      } else {
        import("@/app/anmelden/AnmeldenStepRedirect");
      }
    }
  }, [step]);


  return (
    <div className="home-container">
      <TopSectionMarken
        title="Autoscout24 Alternative – die besten Portale im Vergleich"
        link="/guides/alternative-autoscout24"
        linkname="Autoscout24 Alternative"
        text={
          <>
            84% der Autoeinfachlos-Kunden bekommen mehr Geld.*{" "}
            <br className="desktop" />
            Hol dir deine kostenlose und sofortige Bewertung.
          </>
        }
        removePadding={true}
        step={step}
        setStep={setStep}
        selectedBrand={selectedBrand}
        setSelectedBrand={setSelectedBrand}
        selectedModel={selectedModel}
        setSelectedModel={setSelectedModel}
        selectedYear={selectedYear}
        setSelectedYear={setSelectedYear}
        selectedBauform={selectedBauform}
        setSelectedBauform={setSelectedBauform}
        selectedFuel={selectedFuel}
        setSelectedFuel={setSelectedFuel}
        selectedVariant={selectedVariant}
        setSelectedVariant={setSelectedVariant}
        selectedPs={selectedPs}
        setSelectedPs={setSelectedPs}
        selectedTransmission={selectedTransmission}
        setSelectedTransmission={setSelectedTransmission}
        selectedDoors={selectedDoors}
        setSelectedDoors={setSelectedDoors}
        setSelectedModelType={setSelectedModelType}
        selectedModelType={selectedModelType}
        selectedKmStand={selectedKmStand}
        setSelectedKmStand={setSelectedKmStand}
      />

      {step === 12 && (
        <>
          <AnmeldenSection
            title="Bitte gib deine E-Mail-Adresse ein, um fortzufahren"
            fin={null}
            isManual={isSecondaryMethod}
            marke={selectedBrand}
            model={selectedModel}
            baujahr={selectedYear}
            bodytype={selectedBauform}
            fueltype={selectedFuel}
            variant={selectedVariant}
            ps={selectedPs}
            gearbox={selectedTransmission}
            doors={selectedDoors}
            modelType={selectedModelType}
            kmStand={selectedKmStand}
            page="/auto-verkaufen"
          />
          <Banner removeContent className="Banner-anmelden" />
        </>
      )}

      {step !== 12 && (
        <div className="Page background-color">
          <div className="Page-wrapper">
            <AutoVerkaufenGrid
              image={sellCarCash}
              leftTitle="Warum nach Alternativen suchen?"
              leftText={
                <>
                  <p>
                    AutoScout24 gehört zu den bekanntesten Online-Börsen für
                    Gebrauchtwagen im deutschsprachigen Raum. Doch es gibt
                    inzwischen zahlreiche Alternativen, die je nach Fahrzeugtyp,
                    Preisvorstellung und Zielgruppe attraktive Vorteile bieten
                    können. Dieser Ratgeber vergleicht die größten
                    Autoverkaufsportale in Österreich, bewertet ihre Stärken und
                    Schwächen, erklärt, wie du das richtige Portal findest, und
                    gibt Tipps, worauf du bei der Anzeige achten solltest.
                  </p>

                  <ul className="custom-unordered-list secondary">
                    <li>
                      <strong>Gebühren:</strong> Manche Portale verlangen
                      Inseratsgebühren oder Provisionen. Andere sind kostenlos,
                      bieten aber weniger Service.
                    </li>
                    <li>
                      <strong>Zielgruppe:</strong> Bestimmte Portale richten sich
                      eher an Händler, andere an Privatkäufer.
                    </li>
                    <li>
                      <strong>Reichweite:</strong> Je größer die Reichweite, desto
                      mehr potenzielle Käufer. Doch große Portale können auch zu
                      einer Flut von Anfragen führen, nicht immer seriös.
                    </li>
                    <li>
                      <strong>Spezialisierung:</strong> Einige Plattformen sind
                      auf bestimmte Marken, Oldtimer, Nutzfahrzeuge oder
                      Elektroautos spezialisiert.
                    </li>
                  </ul>

                  <p>
                    Je nach deinen Prioritäten kann die Nutzung von Alternativen
                    zu AutoScout24 effektiver sein.
                  </p>
                </>
              }
              rightFirstTitle="Die wichtigsten Portale im Überblick"
              rightFirstText={
                <>
                  <p>
                    <strong>Willhaben.at</strong>
                  </p>
                  <p>
                    Willhaben ist das größte Kleinanzeigenportal in Österreich
                    und listet regelmäßig über 80 000 Fahrzeuge. Die Inserate
                    sind für Privatverkäufer meist kostenlos, nur Zusatzoptionen
                    wie Platzierungen kosten extra. Dank der enormen Reichweite
                    bekommst du viele Anfragen, musst aber mit ungefilterten
                    Interessenten rechnen. Das Portal eignet sich für
                    alltagstaugliche Fahrzeuge aller Preisklassen.
                  </p>
                  <p>
                    <strong>Vorteile:</strong>
                  </p>
                  <ul className="custom-unordered-list">
                    <li>Kostenlos für Privatverkäufer</li>
                    <li>Große Reichweite und Bekanntheit</li>
                    <li>Einfache Inseratsaufgabe</li>
                    <li>Viele Suchfilter</li>
                  </ul>
                  <p>
                    <strong>Nachteile:</strong>
                  </p>
                  <ul className="custom-unordered-list">
                    <li>Viele unseriöse Anfragen möglich</li>
                    <li>Konkurrenz durch viele ähnliche Fahrzeuge</li>
                  </ul>

                  <p>
                    <strong>Gebrauchtwagen.at</strong>
                  </p>
                  <p>
                    Auf gebrauchtwagen.at inserieren sowohl Händler als auch
                    Privatpersonen. Das Portal ist übersichtlicher als
                    willhaben.at und bietet gezielte Suchoptionen. Für spezielle
                    Fahrzeugtypen (z. B. Luxusfahrzeuge) eignet sich das Portal
                    weniger, da die Zielgruppe dort kleiner ist.
                  </p>
                  <p>
                    <strong>Vorteile:</strong>
                  </p>
                  <ul className="custom-unordered-list">
                    <li>Klare Struktur</li>
                    <li>Fokus auf Gebrauchtwagen</li>
                    <li>Möglichkeit, Inserate prominent zu platzieren</li>
                  </ul>
                  <p>
                    <strong>Nachteile:</strong>
                  </p>
                  <ul className="custom-unordered-list">
                    <li>Geringere Reichweite als willhaben</li>
                    <li>Gebühren für Premiumplatzierungen</li>
                  </ul>

                  <p>
                    <strong>Car4you.at</strong>
                  </p>
                  <p>
                    Car4you bietet rund 50 000 Fahrzeuge und richtet sich eher an
                    professionelle Händler. Privatverkäufer können ebenfalls
                    inserieren, profitieren aber von weniger Kaufanfragen. Das
                    Portal punktet mit fairen Inseratskosten und einer
                    übersichtlichen Oberfläche.
                  </p>
                  <p>
                    <strong>Vorteile:</strong>
                  </p>
                  <ul className="custom-unordered-list">
                    <li>Professionelles Auftreten</li>
                    <li>Gute Händlerkontakte</li>
                    <li>Klare Preisstrukturen</li>
                  </ul>
                  <p>
                    <strong>Nachteile:</strong>
                  </p>
                  <ul className="custom-unordered-list">
                    <li>Geringere Resonanz bei Privatverkäufen</li>
                    <li>Fokus auf bestimmte Marken</li>
                  </ul>

                  <p>
                    <strong>Mobile.de und Kleinanzeigen.de</strong>
                  </p>
                  <p>
                    Als deutsche Portale haben mobile.de und Kleinanzeigen.de
                    (vormals eBay Kleinanzeigen) auch in Österreich eine gute
                    Nutzerbasis. Mobile.de ist stark auf den europäischen Markt
                    ausgerichtet und hat hohe Besucherzahlen, während
                    Kleinanzeigen.de kostenfreie Inserate und lokale Reichweite
                    bietet.
                  </p>
                  <p>
                    <strong>Vorteile:</strong>
                  </p>
                  <ul className="custom-unordered-list">
                    <li>Mobile.de: starke Markenpräsenz und EU-weit erreichbar</li>
                    <li>Kleinanzeigen.de: kostenlose Anzeigen, intuitive Bedienung</li>
                  </ul>
                  <p>
                    <strong>Nachteile:</strong>
                  </p>
                  <ul className="custom-unordered-list">
                    <li>Gebühren bei mobile.de für Zusatzoptionen</li>
                    <li>
                      Starke Konkurrenz und teilweise unseriöse Anfragen bei
                      Kleinanzeigen.de
                    </li>
                  </ul>
                </>
              }
              rightSecondTitle="Bewertete Alternativen laut Tests"
              rightSecondText={
                <>
                  <p>
                    Die Österreichische Gesellschaft für Verbraucherstudien
                    (ÖGVS) testet regelmäßig Online-Autoportale. In einem
                    aktuellen Test landete willhaben.at auf Platz 1, AutoScout24
                    auf Platz 2, mobile.de auf Platz 3. Kriterien waren unter
                    anderem Angebot, Nutzerfreundlichkeit, Servicequalität und
                    Preis-Leistung. Je nach Fokus kann ein anderes Portal besser
                    geeignet sein.
                  </p>

                  <h3>Tipps für die Wahl des passenden Portals</h3>
                  <ul className="custom-unordered-list secondary">
                    <li>
                      <strong>Budget berücksichtigen:</strong> Nutze kostenlose
                      Plattformen für günstige Fahrzeuge. Bei teuren Modellen
                      kann sich ein kostenpflichtiges Inserat mit besserer
                      Platzierung lohnen.
                    </li>
                    <li>
                      <strong>Zielgruppe definieren:</strong> Händlerportale wie
                      car4you eignen sich für spezielle Marken oder luxuriöse
                      Fahrzeuge. Für Kleinwagen und Alltagautos sind willhaben.at
                      und Kleinanzeigen.de ideal.
                    </li>
                    <li>
                      <strong>Mehrere Portale testen:</strong> Steigere die
                      Chancen durch paralleles Inserieren. Achte darauf, dass die
                      Beschreibungen konsistent und ehrlich sind.
                    </li>
                    <li>
                      <strong>Auktionen vermeiden?</strong> Autoauktionen können
                      ein alternativer Vertriebsweg sein, sind aber eher für
                      Händler interessant. Als Privatverkäufer erzielt man selten
                      den gewünschten Preis.
                    </li>
                    <li>
                      <strong>Autoeinfachlos nutzen:</strong> Wenn du dir den
                      Aufwand für Inserate sparen möchtest, bietet Autoeinfachlos
                      eine schnelle Alternative. Mit nur wenigen Daten bekommst du
                      verbindliche Angebote von über 5 000 Händlern in Österreich.
                      Du musst nicht verhandeln, und der Verkauf ist innerhalb von
                      24 Stunden möglich.
                    </li>
                  </ul>
                </>
              }
            />

            <div className="Banner-sections">
              <BildTextInfo
                image={BannerImage3}
                revert
                isBig
                fontSize="36px"
                title="Tipps für ein erfolgreiches Inserat"
                alt="Tipps fuer ein erfolgreiches Inserat beim Autoverkauf"
                text={
                  <>
                    <ul className="custom-unordered-list">
                      <li>
                        <strong>Überschrift klar formulieren:</strong> Nenne
                        Marke, Modell, Baujahr und besondere Merkmale.
                      </li>
                      <li>
                        <strong>Fotos in hoher Qualität:</strong> Zeige das Auto
                        von allen Seiten, auch Innenraum und Motorraum. Licht und
                        Perspektive sollten stimmen.
                      </li>
                      <li>
                        <strong>Ehrliche Angaben:</strong> Liste alle Extras,
                        Schäden und Mängel auf. Unterschlage nichts, das erspart
                        dir Ärger bei Besichtigungen.
                      </li>
                      <li>
                        <strong>Preis realistisch ansetzen:</strong> Informiere
                        dich vorab, was vergleichbare Fahrzeuge kosten. Ein zu
                        hoher Preis schreckt ab.
                      </li>
                      <li>
                        <strong>Erreichbarkeit gewährleisten:</strong> Hinterlasse
                        mehrere Kontaktmöglichkeiten und antworte zeitnah.
                      </li>
                    </ul>
                  </>
                }
              />
            </div>

            <div style={{ paddingTop: "120px" }}>
              <Ratgeber
                title="Mehr zum Thema Autoscout Alternative"
                kaputtesAuto
                unfallAuto
                autoExport
                autoBewerten
                autoVerkaufen
                listenpreisBerechnen
              />
            </div>

            <div className="Banner-sections-marken">
              <BildTextInfo
                image={höchstenPreis}
                h2
                fontSize="36px"
                title="Fazit zu Autoscout24 Alternative"
                alt="Frau sitzt in einem Auto und nutzt ihr Smartphone, um mit Autoeinfachlos schnell und serioes zu verkaufen."
                text={
                  <>
                    <p>
                      AutoScout24 ist ein großer Player, aber nicht der einzige.
                      Je nach Fahrzeug, Budget und Zielgruppe bieten willhaben.at,
                      gebrauchtwagen.at, car4you.at, mobile.de oder
                      Kleinanzeigen.de interessante Alternativen. Vergleiche
                      Reichweite, Kosten und Service und wähle die für dich
                      optimale Plattform. Wenn du unkompliziert und schnell
                      verkaufen möchtest, ohne Inserate zu schalten, ist
                      Autoeinfachlos eine effiziente Lösung.
                    </p>
                  </>
                }
              />
            </div>
          </div>
          <Banner
            link="/auto-verkaufen"
            title="Jetzt Auto kostenlos bewerten & sicher verkaufen"
          />
        </div>
      )}
    </div>
  );
}

export default AlternativeAutoscout24;
